// src/components/Header/Header.tsx

import React, { useState } from "react";
import "./Header.css";
import { useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import { FiMenu } from "react-icons/fi";

// --- STATE IMPORTS ---
import { RootState } from "../../redux/store";
import LogoutButton from "../LogoutButton/LogoutButton";

// --- ICON IMPORTS ---
import chevronDownIcon from "../../assets/images/chevron-down.webp";
import defaultAvatar from "../../assets/images/profile1.png";
import { resolveMediaUrl } from "../../utils/mediaUrl";

interface HeaderProps {
  title: string;
  onMenuClick: () => void;
}

const Header: React.FC<HeaderProps> = ({ title, onMenuClick }) => {
  const [isDropdownOpen, setIsDropdownOpen] = useState(false);
  const user = useSelector((state: RootState) => state.auth.user);
  const navigate = useNavigate();

  const getProfileImage = () =>
    resolveMediaUrl(user?.avatarUrl) || defaultAvatar;

  return (
    <header className="header">
      <button className="mobile-menu-btn" onClick={onMenuClick}>
        <FiMenu />
      </button>

      <div className="header-title">
        <h1>{title}</h1>
      </div>

      <div className="header-controls">
        <div className="user-profile">
          <div
            className="profile-trigger"
            onClick={() => setIsDropdownOpen(!isDropdownOpen)}
          >
            <img
              src={getProfileImage()}
              alt="User Avatar"
              className="avatar"
              onError={(e) => {
                e.currentTarget.src = defaultAvatar;
              }}
            />
            <span className="user-name">{user?.name || "Guest"}</span>
            <img
              src={chevronDownIcon}
              alt="Dropdown"
              className="chevron-down"
            />
          </div>

          {isDropdownOpen && (
            <div className="profile-dropdown">
              <div
                className="dropdown-item"
                onClick={() => navigate("/profile-upload")}
              >
                <span>Profile</span>
              </div>
              <div
                className="dropdown-item"
                onClick={() => navigate("/settings")}
              >
                <span>Settings</span>
              </div>
              <div className="dropdown-divider" />
              <LogoutButton className="dropdown-item logout" />
            </div>
          )}
        </div>
      </div>
    </header>
  );
};

export default Header;
